<div class="subfield" #subfieldElement>
  <pp-custom-field-subfield-number-input
    [ppValue]="'' + ppSubfield.value"
    (ppValueChange)="markInputAsEdited($event)"
    [ppCanEdit]="ppCanEdit"
    [ppUnit]="ppUnit"
    [ppUnitTooltip]="ppUnitTooltip"
    (ppInputChange)="onInputChange($event)"
    [(ppFocused)]="focused"
    [ppDecimalPlaces]="ppDecimalPlaces"
    [ppIsLocked]="ppIsLocked"
  />

  <pp-custom-field-subfield-description-input
    [(ppValue)]="ppSubfield.description"
    (ppValueChange)="markFieldAsEdited()"
    [ppCanEdit]="ppCanEdit"
    [(ppFocused)]="focused"
    (ppDescriptionChange)="onDescriptionChange()"
    [ppIsLocked]="ppIsLocked"
  />

  @if (
    ppCanEdit && saveButtonState === ECustomFieldSubfieldDeleteButtonState.DELETE && !ppIsLocked
  ) {
    <pp-custom-field-subfield-delete-button (ppDeleteSubfield)="deleteSubfield()" />
  }

  @if (
    (ppCanEdit && saveButtonState === ECustomFieldSubfieldDeleteButtonState.CONFIRM) ||
    saveButtonState === ECustomFieldSubfieldDeleteButtonState.CONFIRM_DISABLED
  ) {
    <pp-custom-field-subfield-save-button
      [ppDisabled]="saveButtonState === ECustomFieldSubfieldDeleteButtonState.CONFIRM_DISABLED"
      (ppSaveSubfield)="saveSubfield()"
    />
  }
</div>
